module.exports = __webpack_public_path__ + "static/media/logo-investtor-full-colored.882709f1.svg";